import { useState } from 'react';

import keysToConstants from 'js/lib/keysToConstants';

export const MODAL_TYPES = keysToConstants(['ENROLL', 'GET_CERTIFICATE', 'OPEN_AID', 'PARTNER_SUPPORTED_ACCESS']);

export type ModalType = keyof typeof MODAL_TYPES;

export type UseEnrollmentModalStateResult = {
  activeModal: ModalType | null;
  toggleOpenAidModal: () => void;
  toggleEnrollModal: () => void;
  toggleGetS12nCertificateModal: () => void;
  fromMultipleLearningProgramsLink: boolean | undefined;
  setFromMultipleLearningProgramsLink: (value: boolean | undefined) => void;
};

/**
 * Owns the enroll modal's open/closed state: which modal is active and the
 * mix-and-match "multiple learning programs" entry flag. Toggling a modal type
 * that is already active closes it.
 */
export const useEnrollmentModalState = (): UseEnrollmentModalStateResult => {
  const [activeModal, setActiveModal] = useState<ModalType | null>(null);
  const [fromMultipleLearningProgramsLink, setFromMultipleLearningProgramsLink] = useState<boolean | undefined>(
    undefined
  );

  const toggleModalType = (modalType: ModalType) => {
    setActiveModal(activeModal === modalType ? null : modalType);
  };

  const toggleOpenAidModal = () => {
    toggleModalType(MODAL_TYPES.OPEN_AID);
  };

  const toggleEnrollModal = () => {
    toggleModalType(MODAL_TYPES.ENROLL);
  };

  const toggleGetS12nCertificateModal = () => {
    toggleModalType(MODAL_TYPES.GET_CERTIFICATE);
  };

  return {
    activeModal,
    toggleOpenAidModal,
    toggleEnrollModal,
    toggleGetS12nCertificateModal,
    fromMultipleLearningProgramsLink,
    setFromMultipleLearningProgramsLink,
  };
};

export default useEnrollmentModalState;
